import ClientLoggerFactory from "../../../logging/ClientLoggerFactory";
import { DataStore } from "aws-amplify";
import DataStoreIssueDAO from "./DataStoreIssueDAO";
import DataStoreQueryIssuesByLocationIdPredicateFactory from "./query/filter/DataStoreQueryIssuesByLocationIdPredicateFactory";
import IssueCreationDateSortDirectionAndLimitFactory from "./query/pagination/IssueCreationDateSortDirectionAndLimitFactory";
import { IssueDAO } from "../IssueDAO";
import MockDataStoreIssueDAO from "./MockDataStoreIssueDAO";

export default class DataStoreIssueDAOFactory {
    private static readonly INSTANCE: IssueDAO = new DataStoreIssueDAO(
        DataStore,
        new DataStoreQueryIssuesByLocationIdPredicateFactory(),
        ClientLoggerFactory.getClientLogger("DataStoreIssueDAO"),
        new IssueCreationDateSortDirectionAndLimitFactory()
    );
    private static readonly MOCK_INSTANCE: IssueDAO = new MockDataStoreIssueDAO(
        ClientLoggerFactory.getClientLogger("MockDataStoreIssueDAO"),
    )

    public static getInstance(): IssueDAO {
        if (process.env.REACT_APP_MOCK_ENABLED === "true") {
            return this.MOCK_INSTANCE;
        } else {
            return this.INSTANCE;
        }
    }
}
